import loadable from '@loadable/component'

export const KeyRatingFactor = loadable(() => import('./KeyRatingFactor'))
export type {
  KeyRatingFactorProps,
  KeyRatingFactorPropsItems
} from './KeyRatingFactor'
